export default __webpack_public_path__ + "static/media/graphic design1-01.57bd3cd3.png";